import { axiosInstance } from "../utils/axiosInstance";
import { API_ENDPOINTS } from "../utils/constants";

import { transformDataToSelectOptions } from "../utils";
import { showErrorNotification } from "../components/Notification";

interface ManagerInfo {
	id: string;
	fullName: string;
}

export const getUserList = async (
	pageIndex: number,
	pageSize: number,
	companyIds: string[] = [],
	userIds: string[] = []
) => {
	const response = await axiosInstance.post(API_ENDPOINTS.USER_LIST, {
		orders: [
			{
				"columnName": "fullName",
				"directionDesc": false
			}
		],
		pageIndex: pageIndex,
		pageSize: pageSize,
		search: "",
		userIds: userIds,
		companyIds: companyIds,
		isIncludeCompany: true,
		isIncludeUser: true
	});
	const result = response.data?.result;
	const hasNextPage = response.data?.result?.hasNextPage;

	return [result?.items, hasNextPage];
};

export const getCompanies = async() => {
	try{
		const response = await axiosInstance.post(API_ENDPOINTS.COMPANY_SEARCH, {
			orders: [
				{
					"columnName": "name",
					"directionDesc": false
				}
			],
			pageIndex: 0,
			pageSize: 20000,
			search: null
		});
		const transformedData = transformDataToSelectOptions(response.data?.result?.items, "name", "id");
		return transformedData;
	} catch (error) {
		console.log(error);
	}
};

export const getUdyUsers = async () => {
	try{
		const response = await axiosInstance.post(API_ENDPOINTS.USER_UDY_LIST, {
			orders: [
				{
					"columnName": "fullName",
					"directionDesc": false
				}
			],
			pageIndex: 0,
			pageSize: 500,
			search: "",
			"isIncludeCompany": false,
			"isIncludeUser": true
		});
		const transformedData = transformDataToSelectOptions(response.data?.result?.items, "fullName", "id");
		return transformedData;
	} catch (error) {
		console.log(error);
	}
};

export const getUserInfo = async () => {
	const response = await axiosInstance.get(API_ENDPOINTS.USER_INFO);
	const result = response.data?.result;

	return {
		name: result?.name,
		surname: result?.surname,
		profilePhoto: result?.profilePhoto,
	};
};

export const searchEmployeeUdyList = async (id: string) => {
	try {
		const response = await axiosInstance.post(API_ENDPOINTS.EMPLOYEE_UDY_LIST, {
			orders: [
				{
					"columnName": "fullName",
					"directionDesc": false
				}
			],
			pageIndex: 0,
			pageSize: 500,
			search: "",
			userId: id ? id : "",

		});
		return response.data.result.items.map((item: ManagerInfo) => ({
			label: item.fullName,
			value: item.id,
		}));
	} catch (error) {
		console.error("Unable to fetch managers");
		throw error;
	}
};


export const getGroups = async () => {
	try {
		const response = await axiosInstance.get(API_ENDPOINTS.COMPANY_GROUP_LIST);
		const result = response.data?.result;
		return result;
	} catch (error) {
		showErrorNotification("Unable to fetch groups");
	}
};

export const getTerms = async () => {
	try {
		const response = await axiosInstance.get(API_ENDPOINTS.TERM_LIST);
		return response.data?.result
	} catch (error) {
		showErrorNotification("Unable to fetch groups");
	}
};